// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

on('change', '.js-sponsors-newsletter-tiers input[type="checkbox"]', function (event) {
  const details = event.currentTarget.closest<HTMLElement>('.js-sponsors-newsletter-tiers')!
  const defaultButton = details.querySelector<HTMLElement>('.js-sponsors-newsletter-tiers-default')!
  const countButton = details.querySelector<HTMLElement>('.js-sponsors-newsletter-tiers-count')!
  const showDefaultText = details.querySelector<HTMLElement>('[data-check-all-count]')!.textContent === '0'

  defaultButton.hidden = !showDefaultText
  countButton.hidden = showDefaultText
})
